import { IPurchase } from "../models/Purchase";
import { formatCurrencyBRL, formatNumberBR } from "./format";

// ---------------------------------------------------------------
// Helpers anti-NaN/Infinity
// ---------------------------------------------------------------
const toNumber = (v: unknown): number => {
    const n = typeof v === "number" ? v : Number(v);
    return Number.isFinite(n) ? n : 0;
};

const safeDivide = (a: number, b: number): number | null => {
    if (b === 0 || !Number.isFinite(b)) return null;
    const result = a / b;
    return Number.isFinite(result) ? result : null;
};

const DASH = "—";

// ---------------------------------------------------------------
// Public API
// ---------------------------------------------------------------
export const fomartAmountBought = (paymentInfo?: IPurchase): string => {
    if (!paymentInfo) return DASH;
    const amount = safeDivide(toNumber(paymentInfo.value), toNumber(paymentInfo.quotation_organization));
    if (amount === null) return DASH;
    return formatNumberBR(amount);
};

export const formatAmountPaidToTarget = (paymentInfo?: IPurchase): string => {
    if (!paymentInfo) return DASH;
    const amount = safeDivide(toNumber(paymentInfo.value), toNumber(paymentInfo.quotation_organization));
    if (amount === null) return DASH;
    const total = amount * toNumber(paymentInfo.quotation_real);
    if (!Number.isFinite(total)) return DASH;
    return formatCurrencyBRL(total);
};

export const formatProfit = (paymentInfo?: IPurchase): string => {
    if (!paymentInfo) return DASH;
    const amount = safeDivide(toNumber(paymentInfo.value), toNumber(paymentInfo.quotation_organization));
    if (amount === null) return DASH;

    const totalOrganizationPaid = amount * toNumber(paymentInfo.quotation_real);
    const totalOriginPaid       = amount * toNumber(paymentInfo.quotation_organization);
    const profit                = totalOriginPaid - totalOrganizationPaid;

    if (!Number.isFinite(profit)) return DASH;
    return formatCurrencyBRL(profit);
};

export const formatPercentage = (paymentInfo?: IPurchase): string => {
    if (!paymentInfo) return DASH;
    const A = toNumber(paymentInfo.quotation_organization);
    const B = toNumber(paymentInfo.quotation_real);

    const pct = safeDivide(A - B, B);
    if (pct === null) return DASH;
    return (pct * 100).toFixed(2) + "%";
};

/** Numero bruto do lucro — util pra colorir (positivo verde / negativo magenta). */
export const profitValue = (paymentInfo?: IPurchase): number | null => {
    if (!paymentInfo) return null;
    const amount = safeDivide(toNumber(paymentInfo.value), toNumber(paymentInfo.quotation_organization));
    if (amount === null) return null;
    const profit = amount * (toNumber(paymentInfo.quotation_organization) - toNumber(paymentInfo.quotation_real));
    return Number.isFinite(profit) ? profit : null;
};
